import { useState } from "react"

export const ReconciliationState = () => {
    const [date, setDate] = useState();
    const [isToReconcile, setIsToReconcile] = useState(true);
    const [loader, setLoader] = useState({isLoader:false, isShowWarningModal:false, warningMessage: '', isShowData: false, isGenerate: false})
    const [remarks, setRemarks] = useState(true);
    const [toReconcileList, setToReconcileList] = useState([]);
    const [reconciledList, setReconciledList] = useState([]);
    const [toReconcile, setToReconcile] = useState({branch_id: "", date:'', branch_sales_id: ""});
    const [dateForm, setDateForm] = useState({date_from:'', date_to:'',})
    const [snackBarLoader, setSnackBarLoader] = useState({snackbar:false, msg:'', type:''})
    const [infiniteState, setInfiniteState] = useState({limit:20, offset:0, infiniteLoad:false, dataType:'string'});
    const [reconData, setReconData] = useState({id: "",date: "", reconciledRemarks:"", status:1, remarks: "", firstName: "", lastName: "", totalSales: 0, actualCash: 0, reconciledSales: 0, branchName: "" });
    const [submitFormLoader, setSubmitFormLoader] = useState({modal:false, loader:false, submitted:true})
    const [declineFormLoader, setDeclineFormLoader] = useState({modal:false, loader:false, submitted:true})
    
    const [form, setForm] = useState({branch_id:0, from:'', to:''})
    const [generateForm, setGenerateForm] = useState({infiniteLoad:false, limit:100, offset:0})


    return {
        date: {data: date, set: setDate},
        loader: {data: loader, set: setLoader},
        isToReconcile: {data: isToReconcile, set: setIsToReconcile},
        remarks: {data: remarks, set: setRemarks},
        toReconcileList: {data: toReconcileList, set: setToReconcileList},
        reconciledList: {data: reconciledList, set: setReconciledList},
        toReconcile: {data: toReconcile, set: setToReconcile},
        dateForm: {data: dateForm, set: setDateForm},
        reconData: {data: reconData, set: setReconData},
        snackBarLoader: {data: snackBarLoader, set: setSnackBarLoader},
        infiniteState: {data: infiniteState, set: setInfiniteState},
        submitFormLoader:{data: submitFormLoader, set: setSubmitFormLoader},
        declineFormLoader:{data: declineFormLoader, set: setDeclineFormLoader},
        
        form: {data: form, set: setForm},
        generateForm: {data: generateForm, set: setGenerateForm},

    }
}